import React, { Component } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from './Store/actions';
import { DragDropContext } from 'react-beautiful-dnd';

import Cluster from './Support/Cluster';

import Home from './Pages/Home';
import Register from './Pages/Register';
import Profile from './Pages/Profile';
import ResetPassword from './Pages/ResetPassword';
import Dashboard from './Pages/Dashboard';
import NewMatter from './Pages/NewMatter';
import Matter from './Pages/Matter';
import Logout from './Pages/Logout';
import Blank from './Pages/Blank';

import Footer from './Blocks/Footer';
import Modal from './Blocks/Modal';
import Toast from './Blocks/Toast';
import Loader from './UI/Loader';


class App extends Component {

	componentDidMount() {
		this.props.rdxPreauth();
	}

	onDragStart = () => {
		/*...*/
	};

	onDragUpdate = () => {
		/*...*/
	};

	onDragEnd = (result) => {
		if(!result.destination) return;
		const row_from = +result.source.index;
		const row_to = +result.destination.index;
		if(row_from === row_to) return;
		this.props.rdxShiftRow(result.source.droppableId,row_from,row_to);
	};

	render() {

		if(!this.props.authChecked)
			return <Loader />;

		let layout_footer = <Footer />;
		if(window.location.pathname === '/') layout_footer = null;

		return (
			<DragDropContext onDragStart={this.onDragStart} onDragUpdate={this.onDragUpdate} onDragEnd={this.onDragEnd}>
				<Cluster>
					<Switch>
						<Route path="/" exact component={Home} />
						<Route path="/register" component={Register} />
						<Route path="/dashboard" component={Dashboard} />
						<Route path="/profile" component={Profile} />
						<Route path="/reset-password" component={ResetPassword} />
						<Route path="/matter/new" exact component={NewMatter} />
						<Route path="/matter/:id" component={Matter} />
						<Route path="/logout" component={Logout} />
						<Route component={Blank} />
					</Switch>
					<Modal />
					{layout_footer}
					<Toast />
				</Cluster>
			</DragDropContext>
		);
	}

}


const mapStateToProps = state => {
	return {
		authChecked: state.authChecked
	};
}

const mapDispatchToProps = dispatch => {
	return {
		rdxShiftRow: (id,row,to) => dispatch(actions.shiftRow(id,row,to)),
		rdxPreauth: () => dispatch(actions.preauth())
	};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));


// WEBPACK FOOTER //
// ./src/App.js